// extracted by mini-css-extract-plugin
export var avatar = "_lh-3";
export var avatarContainer = "_lh-2";
export var avatarSpacer = "_lh-5";
export var avatarSpacerContainer = "_lh-4";
export var avatarStackContainer = "_lh-1";
export var bubble = "_lh-0";
export var remainderBubble = "_lh-6";